import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';
import { CHECK_AVAILABILITY, CLAIM_REIMBURSEMENT, CONFIRM_RECALL, DEDUCTIBLE_AMOUNT, GET_BRANDS, GET_CATEGORY_ITEMS, GET_COVERED_ITEMS, GET_COVERED_TRADES, GET_ITEMS, GET_ITEMS_LOCATIONS, GET_JOBS_BY_MODEL, GET_LOCATIONS, GET_RECALL_AVAILABILITY, GET_SEARS_ACCOUNT_NUMBERS, GET_SYMPTOMS_FOR_SELECTED_ITEM, getApiUrlForParams, PARSE_APPLIANCE_TAG, PM_ITEMS, SAVE_CLAIM_INFO, SUBMIT_CLAIM, toQueryString, VALIDATE_AUTOMATIC_DECISION } from '../../utils/api.util';
import { HttpService } from '../http/http.service';
import { catchError, distinctUntilChanged, map, Observable, of, switchMap, takeUntil, tap } from 'rxjs';
import { IAvailability, IAvailabilityUrlLocation, IClaimReimbursementResponse, ICategoryBrand, ICategoryItems, IClaimResponse, IConfirmRecallPayload, ICoveredCategory, IDeductibleReqParams, IDeductibleResponse, IItemsAndLocationsResponse, IJobByModelResponse, IPMItem, IPostData, IRecallAvailabilityPayload, ISaveClaimInfoRes, IScheduleRequestForce, ISelectedItemSymptoms, ISelectedProduct, ISubmitClaimItems, ISubmitClaimReqParams, IValidateAutomaticDecision, IValidateAutomaticDecisionResponse, IClaimReimbursementPayload, IExtractBarcodeResponse, IItemAndLocations, ISaveClaimResponse } from '../../components/pages/service-request/service-request.interface';
import { UtilitiesService } from '../utilities/utilities.service';
import { environment } from '../../../environments/environment';
import { BYOP_PLAN, SRG_PLANS } from '../../utils/constants';
import { ROOF_LEAK_CATEGORY_ID } from '../../components/pages/service-request/service-request.constants';
import { ROOF_LEAK_ENABLED } from '../../utils/feature-flags';
import { HttpHeaders } from '@angular/common/http';
import { IPurchaseEventItem } from '../ga4/ga4.interface';
import { formatStraightCoolItemName } from '../../utils/helper';

@Injectable({
  providedIn: 'root'
})
export class ServiceRequestService {
  private get httpOptions() {
    return {
      headers: new HttpHeaders(this.httpService.getHeaders(this.dataService.vivrAccessToken$.value)),
    };
  }
  private iconMap: { [key: string]: string } = {
    '81': 'refrigerator',
    '248': 'house',
    '83': 'dryer',
    '84': 'dryer',
    '85': 'dryer',
    '86': 'washer',
    '88': 'stove top',
    '89': 'stove top',
    '90': 'stove top',
    '91': 'dishwasher',
    '93': 'house',
    '94': 'food processor',
    '95': 'freezer',
    '96': 'microwave',
    '98': 'oven',
    '99': 'oven',
    '100': 'oven',
    '101': 'refrigerator',
    '103': 'trash compactor',
    '105': 'wall oven',
    '106': 'wall oven',
    '107': 'wall oven',
    '108': 'house',
    '109': 'house',
    '110': 'systems',
    '111': 'house',//attic-fan
    '112': 'house',
    '113': 'ceiling fan',
    '114': 'house',
    '3234': 'house',
    '120': 'electrical',
    '116': 'house',
    '3247': 'house',
    '117': 'house',//light switch
    '119': 'house',//elec wiring
    '125': 'garage door opener',
    '126': 'garage door opener',
    '127': 'hvac',
    '129': 'hvac',
    '130': 'house',
    '131': 'house',
    '132': 'house',
    '133': 'house',
    '134': 'house',
    '135': 'house',
    '136': 'house',
    '137': 'house',
    '138': 'house',
    '139': 'house',
    '140': 'house',
    '149': 'house',
    '150': 'house',
    '151': 'house',
    '152': 'house',
    '159': 'heating',
    '160': 'house',
    '161': 'house',
    '162': 'house',
    '163': 'house',
    '169': 'repair',
    '170': 'repair',
    '175': 'plumbing 2',
    '176': 'house',
    '1782': 'house',
    '177': 'house',
    '178': 'garbage disposal',
    '182': 'house',//gas line
    '183': 'house',
    '2788': 'house',//plumbing stoppages
    '184': 'house',
    '395': 'house',
    '185': 'house',
    '195': 'water heater',
    '196': 'water heater',
    '197': 'water heater',
    '198': 'water heater',
    '193': 'house',
    '186': 'house',
    '187': 'toilet',
    '3010': 'house',//tub shower valve
    '1843': 'house',
    '181': 'house',
    '396': 'house',
    '180': 'house',//water line
    '3981': 'septic w sewage ejector',
    '4124': 'gas line',
    '3978': 'house',
    '4123': 'sewer line',
    '4125': 'outside water line',
    '4146': 'house',
    '4161': 'house',
    '4164': 'house',
    '4153': 'house',
    '4154': 'house',
    '4162': 'house',
    '4150': 'house',//laptop
    '4158': 'house',
    '4152': 'house',
    '4155': 'house',
    '4156': 'house',
    '4163': 'house',
    '4157': 'house',
    '4151': 'house',
    '4160': 'house',
    '201': 'pool w heater',
    '398': 'pool w heater',
    '399': 'pool w heater',
    '397': 'pool & spa w heater',
    '400': 'spa w heater',
    '205': 'house',
    '204': 'house',
    '203': 'house',
    '207': 'house',
    '5349': 'house',
    '211': 'house',
    '5422': 'house',
    '209': 'house',
    '5379': 'house',
    '208': 'house',
    '5450': 'house',
    '210': 'house',
    '5399': 'house',
    '212': 'house',
    '213': 'house',
    '217': 'house',
    '216': 'house',
    '215': 'house',
    '219': 'house',
    '223': 'house',
    '221': 'house',
    '220': 'house',
    '222': 'house',
    '224': 'house',
    '225': 'house',
    '2027': 'house',
    '2036': 'house',
    '229': 'house',
    '228': 'house',
    '227': 'house',
    '231': 'house',
    '232': 'house',
    '233': 'house',
    '234': 'house',
    '235': 'house',
    '236': 'house',
    '237': 'house',
    '243': 'water softner',
    '244': 'water softner',
    '245': 'well pump',
    '246': 'well pump',
    '3523': 'hvac',
    '3524': 'hvac',
    '3541': 'heating',
    '3722': 'plumbing 2',
    '3723': 'electrical',
    '3493': 'refrigerator',
  };

  private lastRequestSignature: string | null = null;
  private latestInFlightSignature: string | null = null;

  constructor(private dataService: DataService, private httpService: HttpService, private util: UtilitiesService) { }

  getEligibleCategories(contractNumber: string, productId: string, isVivr: boolean = false, vivrSub: string = ''): Observable<ICoveredCategory> {

    const auth0Id = isVivr ? (this.dataService.vivrSub$.getValue() || vivrSub) : this.dataService.auth0UserId.getValue();
    const url = getApiUrlForParams(GET_COVERED_TRADES, { auth0Id, contractNumber, productId });
    const currentSignature = `${auth0Id}_${contractNumber}_${productId}_${isVivr}`;
    this.latestInFlightSignature = currentSignature;
    return this.httpService.get<ICoveredCategory>(url, isVivr ? this.httpOptions : undefined).pipe(
      tap((response) => {
        if (this.latestInFlightSignature === currentSignature) {
          this.lastRequestSignature = currentSignature;
          this.dataService.coveredCategories$.next(response);
        }
      })
    );
  }

  getEligibleCategoriesCached(contractNumber: string, productId: string, isVivr: boolean = false, vivrSub: string = ''): Observable<ICoveredCategory> {
    const auth0Id = isVivr ? (this.dataService.vivrSub$.getValue() || vivrSub) : this.dataService.auth0UserId.getValue();
    const currentSignature = `${auth0Id}_${contractNumber}_${productId}_${isVivr}`;
    const cached = this.dataService.coveredCategories$.getValue();
    if (cached && this.lastRequestSignature === currentSignature) {
      return of(cached);
    }
    return this.getEligibleCategories(contractNumber, productId, isVivr, vivrSub);
  }

  checkLocksmithAvailability(cleaner$: Observable<void>): Observable<boolean> {
    return this.dataService.contractData$.pipe(
      distinctUntilChanged((prev, curr) => prev?.baseContract?.contractNumber === curr?.baseContract?.contractNumber && prev?.baseContract?.productId === curr?.baseContract?.productId),
      switchMap(contract => {
        if (!contract?.baseContract) {
          return of(false);
        }
        return this.getEligibleCategoriesCached(
          contract.baseContract.contractNumber,
          contract.baseContract.productId
        ).pipe(
          map(categories => categories?.categoryIds?.includes(169) || false),
          catchError((err) => {
            console.error('Error fetching covered categories/trades', err);
            return of(false);
          })
        );
      }),
      takeUntil(cleaner$)
    );
  }

  getCategoryData(isVivr: boolean = false): Observable<ICategoryItems[]> {
    const categoriesList = this.dataService.categoriesList$.getValue();

    return categoriesList ? of(categoriesList) : this.httpService.get<ICategoryItems[]>(GET_CATEGORY_ITEMS, isVivr ? this.httpOptions : undefined).pipe(
      tap((response) => {
        this.dataService.categoriesList$.next(response);
      })
    );
  }

  getEligibleItems(contractNumber: string, productId: string, isVivr: boolean = false, vivrSub: string = ''): Observable<ICoveredCategory> {

    const auth0Id = isVivr ? (this.dataService.vivrSub$.getValue() || vivrSub) : this.dataService.auth0UserId.getValue();
    const url = getApiUrlForParams(GET_COVERED_ITEMS, { auth0Id, contractNumber, productId });
    return this.httpService.get<ICoveredCategory>(url, isVivr ? this.httpOptions : undefined).pipe(
      tap((response) => {
        this.dataService.coveredItems$.next(response);
      })
    );
  }

  iconLookUp(id: string): string {
    return this.iconMap[id] || 'house';
  }

  getDefaultQuickLinkItems() {
    return [
      { name: 'Refrigerator', item: '101', icon: 'plan-appliance', category: 'Appliance', value: '81' },
      { name: 'Clothes Washer', item: '86', icon: 'washer', category: 'Appliance', value: '81' },
      { name: 'Central AC', item: '129', icon: 'job-hvac', category: 'HVAC', value: '127' },
      { name: 'Dishwasher', item: '91', icon: 'dishwasher', category: 'Appliance', value: '81' },
      { name: 'Central Heat', item: '159', icon: 'heating', category: 'HVAC', value: '127' },
      { name: 'Microwave', item: '96', icon: 'microwave', category: 'Appliance', value: '81' },
      { name: 'Toilet', item: '187', icon: 'toilet', category: 'Plumbing or Plumbing Stoppage', value: '175' },
      { name: 'Water Heater', item: '195', icon: 'water-heater', category: 'Plumbing or Plumbing Stoppage', value: '175' },
      { name: 'Other', item: 'OTHER', icon: 'home-gear' }
    ];
  }

  getPreventiveMaintenanceItems(contractNumber: string, isVivr: boolean = false, isPlanFFS: boolean = false): Observable<IPMItem[]> {

    // Determine params based on plan type
    let url = getApiUrlForParams(PM_ITEMS, { contractNumber });
    if (isPlanFFS) {
      url += `?isFfs=${isPlanFFS}`;
    }
    return this.httpService.get<IPMItem[]>(url, isVivr ? this.httpOptions : undefined).pipe(
      tap((response) => {
        this.dataService.serviceRequestPMData$.next(response);
      })
    );
  }

  getItemsAndLocations(categoryId: string, isVivr: boolean = false): Observable<IItemsAndLocationsResponse> {


    const url = getApiUrlForParams(GET_ITEMS_LOCATIONS, { categoryId });

    const request$ = this.httpService.get<IItemsAndLocationsResponse>(url, isVivr ? this.httpOptions : undefined);

    return request$.pipe(
      map((response) => {
        // Appends ' (Air Conditioner)' suffix to items starting with 'Straight Cool' (e.g. 'Straight Cool <= 5 Tons').
        // This helper is needed to improve searchability and user selection clarity under the HVAC category
        // (per Jira CX-5278), without mutating the original cached items or affecting API payload ID submissions.
        if (response && Array.isArray(response.items)) {
          response.items = response.items.map(item => formatStraightCoolItemName(item));
        }
        return response;
      }),
      tap((response) => {
        this.dataService.serReqSubCategoryLocations$.next(response);
      })
    );
  }

  getSymptoms(selectedItem: string, isVivr: boolean = false): Observable<ISelectedItemSymptoms[]> {

    const url = getApiUrlForParams(GET_SYMPTOMS_FOR_SELECTED_ITEM, { selectedItem })
    return this.httpService.get<ISelectedItemSymptoms[]>(url, isVivr ? this.httpOptions : undefined);
  }

  getBrands(isVivr: boolean = false): Observable<ICategoryBrand[]> {
    const brandsList = this.dataService.brandsList$.getValue();

    return brandsList ? of(brandsList) : this.httpService.get<ICategoryBrand[]>(GET_BRANDS, isVivr ? this.httpOptions : undefined).pipe(
      tap((response) => {
        this.dataService.brandsList$.next(response);
      })
    );
  }

  getSearsAccountNumbers(isVivr: boolean = false): Observable<string[]> {

    return this.httpService.get<string[]>(GET_SEARS_ACCOUNT_NUMBERS, isVivr ? this.httpOptions : undefined);
  }

  validateAutomaticDecision(validateAutomaticDecisionPayload: IValidateAutomaticDecision, isVivr: boolean = false): Observable<IValidateAutomaticDecisionResponse> {

    return this.httpService.post<IValidateAutomaticDecisionResponse>(VALIDATE_AUTOMATIC_DECISION, validateAutomaticDecisionPayload, isVivr ? this.httpOptions : undefined);
  }

  saveClaim(contractNo: string, itemId: string, isVivr: boolean = false): Observable<ISaveClaimResponse> {

    const url = getApiUrlForParams(SAVE_CLAIM_INFO, { contractNo, itemId })
    return this.httpService.get<ISaveClaimResponse>(url, isVivr ? this.httpOptions : undefined);
  }

  checkAvailability(contractNo: string, data: IPostData, isVivr: boolean = false): Observable<IAvailabilityUrlLocation> {

    const url = getApiUrlForParams(CHECK_AVAILABILITY, { contractNo });
    return this.httpService.post<IAvailabilityUrlLocation>(url, data, isVivr ? this.httpOptions : undefined);
  }

  /**
+   * Makes a recursive GET call to the specified endpoint
+   * @param url The endpoint URL (without /api/ prefix)
+   * @returns Observable with the response from the API
+   */
  recursiveGetCall<T>(url: string, isVivr: boolean = false): Observable<T> {

    return this.httpService.get<T>('api/' + url, isVivr ? this.httpOptions : undefined);
  }

  getDeductibleForClaim(contractNo: string, deductibleReqParams: IDeductibleReqParams, isVivr: boolean = false): Observable<IDeductibleResponse> {

    const auth0Id = isVivr ? this.dataService.vivrSource$.getValue() : this.dataService.auth0UserId.getValue();
    const url = getApiUrlForParams(DEDUCTIBLE_AMOUNT, { auth0Id, contractNo })
    return this.httpService.post<IDeductibleResponse>(url, deductibleReqParams, isVivr ? this.httpOptions : undefined);
  }

  submitClaimForValidation(params: ISubmitClaimReqParams, isVivr: boolean = false): Observable<ISaveClaimInfoRes> {

    return this.httpService.post<ISaveClaimInfoRes>(SUBMIT_CLAIM, params, isVivr ? this.httpOptions : undefined);
  }

  mapSelectedProductsToClaimItems(): ISubmitClaimItems[] | null {
    if (!this.dataService.serviceRequestSelectedProducts$.value || !this.dataService.contractData$.value) {
      return null;
    }
    const isPlanFFS = this.dataService.isPlanFFS();
    const isPlanFFSSelected = this.dataService.isPlanFFSSelected$.getValue();
    const ffsServiceFee = isPlanFFSSelected?.serviceFee != null ? Number(isPlanFFSSelected?.serviceFee) : undefined;
    const hasValidFFSFee = typeof ffsServiceFee === 'number' && Number.isFinite(ffsServiceFee) && ffsServiceFee >= 0;
    return this.dataService.serviceRequestSelectedProducts$.value.map((serReq: ISelectedProduct) => {
      return {
        ...serReq,
        // These attributes symptoms and brands are supposed to be dropped as they are not needed by the API
        // TBD to modify the interface and methods using it later
        symptoms: [],
        brands: [],
        burkeInfo: {
          ...serReq.burkeInfo,
          complaintCode: serReq.burkeInfo.legacyCode,
        },
        deductible: serReq.replacementDeductibleDue ? 0 : ((isPlanFFS && isPlanFFSSelected) && hasValidFFSFee ? ffsServiceFee : serReq.deductible),
        id: serReq.itemId,
        categoryId: serReq.itemId,
        modelNumber: serReq.model,
        scheduleRequest: serReq.scheduleRequest || this.scheduleRequestByForceBooking(serReq),
        replacementDeductible: serReq.replacementDeductibleDue,
        serialNumber: serReq.serialNo,
        source: null,
        surcharge: 0
      };
    });
  }

  private scheduleRequestByForceBooking(serReq: ISelectedProduct): IScheduleRequestForce {
    if (ROOF_LEAK_ENABLED && serReq.itemId === ROOF_LEAK_CATEGORY_ID) {
      return {
        claimType: null,
        forceBooked: true,
        requestServiceProviderAccount: environment.roofLeakServiceProvider,
      };
    }
    if (!this.isItemAvailable(serReq.itemId)) {
      return {
        claimType: null,
        forceBooked: true,
        requestServiceProviderAccount: environment.procureVendorServiceProvider,
      };
    } else {
      return {
        claimType: null,
        forceBooked: true,
        requestServiceProviderAccount: this.getServiceProvider(),
        microwaveType: serReq.microwaveType,
      };
    }
  }

  /**
* Checks if the item with the given itemId is available, including Procure Vendor logic.
*  which determines if the item
* should be assigned to the Procure Vendor service provider when unavailable.
*
* @param itemId - The ID of the item to check availability for.
* @returns True if the item is available, false otherwise (including Procure Vendor assignment).
*/
  isItemAvailable(itemId: string): boolean {
    const itemAvailabilityResults = this.dataService.itemAvailabilityResults$.getValue();
    if (!itemAvailabilityResults || itemAvailabilityResults.length === 0) {
      // No availability context yet — fall back to normal SP routing
      return true;
    }
    const result = itemAvailabilityResults?.find(res => res.itemId === itemId);
    return result ? result.available : true;
  }

  private getServiceProvider(): string {
    const { coverageGroup } = this.dataService.contractData$.value?.baseContract || {};
    if (!coverageGroup) { return ''; }
    // Map coverage groups to service providers
    const assignSPByCoverageGroup: { [plan: string]: string } = {
      [SRG_PLANS[0]]: environment.SrgOrTxSrgServiceProviders.Srg, // SURGE
      [SRG_PLANS[1]]: environment.SrgOrTxSrgServiceProviders.TxSrg, // TXU SURGE
      [BYOP_PLAN]: environment.ByopServiceProvider,
      'default': environment.automaticDecision.serviceProvider
    };
    return assignSPByCoverageGroup[coverageGroup] || assignSPByCoverageGroup['default'];
  }

  getJobsByModel(contractNo: string, payload: Record<string, string | number | undefined>): Observable<IJobByModelResponse[]> {
    const queryParams = toQueryString(payload);
    const url = getApiUrlForParams(GET_JOBS_BY_MODEL, { contractNo });
    return this.httpService.get<IJobByModelResponse[]>(url + queryParams);
  }

  getRecallAvailability(contractNo: string, payload: IRecallAvailabilityPayload): Observable<IAvailability> {
    const queryParams = toQueryString(payload);
    const url = getApiUrlForParams(GET_RECALL_AVAILABILITY, { contractNo });
    return this.httpService.get<IAvailability>(url + queryParams);
  }

  confirmRecallItem(payload: IConfirmRecallPayload) {
    return this.httpService.post<IClaimResponse>(CONFIRM_RECALL, payload);
  }

  public claimReimbursement(contractNumber: string, serviceJobId: string, payload: IClaimReimbursementPayload): Observable<IClaimReimbursementResponse | null> {
    const auth0Id = this.dataService.auth0UserId.getValue();
    if (!auth0Id) { return of(null); }
    const url = getApiUrlForParams(CLAIM_REIMBURSEMENT, { auth0Id, contractNumber, serviceJobId });
    return this.httpService.post<IClaimReimbursementResponse>(url, payload).pipe(
      map(res => ({ ...res, serviceJobId })),
      catchError(() => of(null))
    );
  }

  mapSelectedItemsForGa4(coverageGroup: string): IPurchaseEventItem[] | [] {
    const selectedItems = this.dataService.serviceRequestSelectedProducts$.value
    const listOfItems: IPurchaseEventItem[] = selectedItems.map((selectedItem, index) => {
      return {
        index: index,
        item_brand: selectedItem.brand,
        affiliation: coverageGroup,
        item_category: selectedItem.location,
        item_category2: selectedItem.burkeInfo['symptomDescription'],
        item_id: selectedItem.itemId,
        item_list_name: selectedItem.category,
        item_name: selectedItem.item,
        item_variant: selectedItem.model,
        price: selectedItem.deductible + (selectedItem.surcharge ?? 0),
      };
    })
    return listOfItems;
  }

  getItems(): Observable<any> {
    const itemsList = this.dataService.itemsList$.getValue();
    return itemsList ? of(itemsList) :
      this.httpService.get<any>(GET_ITEMS).pipe(
        // Appends ' (Air Conditioner)' suffix to items starting with 'Straight Cool' (e.g. 'Straight Cool <= 5 Tons').
        // This helper is needed to improve searchability and user selection clarity under the HVAC category
        // (per Jira CX-5278), without mutating the original cached items or affecting API payload ID submissions.
        map((response) => {
          if (Array.isArray(response)) {
            return response.map(item => formatStraightCoolItemName(item));
          }
          return response;
        }),
        tap((response) => {
          this.dataService.itemsList$.next(response);
        })
      )
  }

  getLocations(): Observable<any> {
    const locationsList = this.dataService.locationsList$.getValue();
    return locationsList ? of(locationsList) :
      this.httpService.get<any>(GET_LOCATIONS).pipe(
        tap((response) => {
          this.dataService.locationsList$.next(response);
        })
      )
  }

  parseApplianceTag(file: File, isVivr: boolean): Observable<IExtractBarcodeResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const auth0Id = this.dataService.auth0UserId.getValue();
    const url = getApiUrlForParams(PARSE_APPLIANCE_TAG, { auth0Id });

    // Clone headers to safely manipulate them without affecting other API calls
    const headersObj: { [key: string]: string } = isVivr
      ? this.httpService.getHeaders(this.dataService.vivrAccessToken$.getValue())
      : this.httpService.getHeaders();

    // CRITICAL for FormData: Delete Content-Type to let the browser automatically set the correct multipart boundary
    delete headersObj['Content-Type'];
    const options = { headers: new HttpHeaders(headersObj) };

    return this.httpService.post<IExtractBarcodeResponse>(url, formData, options);
  }
}
